import {
  ChangeDetectionStrategy,
  Component,
  Input,
  TemplateRef,
} from '@angular/core';
import {
  IImageBreakpoint,
  IMedia,
  MediaObjectFit,
  MediaType,
} from '@epicuro-next/ataraxia/models';

/**
 * Component responsible for rendering Media elements:
 * Video, images
 */
@Component({
  selector: 'atx-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MediaComponent {
  /** The media element to show. */
  @Input() public media: IMedia;
  @Input() public fallbackImageUrl?: string;
  @Input() public videoPlayerProps: Partial<HTMLVideoElement>;
  @Input() public objectFit: MediaObjectFit = MediaObjectFit.CONTAIN;
  @Input() public videoPosterUrl?: string;
  @Input() public maxWidth?: number;
  @Input() public imageBreakpoints?: IImageBreakpoint[];
  @Input() public imageTemplateRef: TemplateRef<unknown>;

  public MediaType = MediaType;
}
